/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement, KeyboardEvent } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUsers,
  faMoneyBill,
  faMapMarkerAlt,
  faPhoneAlt,
  faGlobeAmericas,
  faDesktop,
} from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faTwitterSquare, faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import _ from 'lodash'
import Spinner from '../../Spinner'
import newWindow from '../../../utils/newWindow'
import './styles.scss'
import CircleCheckbox from '../../CircleCheckbox'

const AdminCompanyInfo: FC<any> = ({ companyInfo, localDomain }) => {
  const noCompanies = (
    <>
      <h3>No matching companies found</h3>
      <p>If you think this is a mistake, please contact support</p>
    </>
  )

  let content: ReactElement | null = null
  if (!localDomain) {
    content = noCompanies
  } else if (companyInfo?.isLoading) {
    content = <Spinner />
  } else if (!companyInfo?.company) {
    content = noCompanies
  } else if (companyInfo?.company) {
    const companyAddress = companyInfo.company.address
    let address = ''

    if (companyAddress.state) {
      address = `${companyAddress.state}`

      if (companyAddress.city) {
        address = `${companyAddress.city}, ${address}`

        if (companyAddress.street) {
          address = `${companyAddress.street} ${address}`
        }
      }
    }

    content = (
      <div className="company">
        {companyInfo.company.headCount && (
          <div className="head-count info">
            <FontAwesomeIcon icon={faUsers} size="lg" color="#58585B" />
            <p>{`${companyInfo.company.headCount} Employees`}</p>
          </div>
        )}
        {companyInfo.company.revenueBucket && (
          <div className="revenue-bucket info">
            <FontAwesomeIcon icon={faMoneyBill} size="lg" color="#58585B" />
            <p>{companyInfo.company.revenueBucket}</p>
          </div>
        )}
        {!_.isEmpty(companyInfo.company.address) && (
          <div className="address info">
            <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" color="#58585B" />
            <p>{address}</p>
          </div>
        )}
        {companyInfo.company.phoneNumber && (
          <div className="phone-number info">
            <FontAwesomeIcon icon={faPhoneAlt} size="lg" color="#58585B" />
            <p>{companyInfo.company.phoneNumber.number}</p>
          </div>
        )}
        {companyInfo.company.website && (
          <div className="website info">
            <FontAwesomeIcon icon={faGlobeAmericas} size="lg" color="#58585B" />
            <p>
              <button
                className="button-link"
                onClick={(): void => {
                  newWindow(`${companyInfo.company?.website}`, '')
                }}
                onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void => {
                  if (e.keyCode === 13) {
                    newWindow(`${companyInfo.company?.website}`, '')
                  }
                }}
                type="button"
              >
                View Website
              </button>
            </p>
          </div>
        )}
        {companyInfo.company.linkedin && (
          <div className="linkedin info">
            <FontAwesomeIcon icon={faLinkedinIn} size="lg" color="#58585B" />
            <p>
              <button
                className="button-link"
                onClick={(): void => {
                  newWindow(`${companyInfo.company?.linkedin}`, '')
                }}
                onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void => {
                  if (e.keyCode === 13) {
                    newWindow(`${companyInfo.company?.linkedin}`, '')
                  }
                }}
                type="button"
              >
                View LinkedIn Profile
              </button>
            </p>
          </div>
        )}
        {companyInfo.company.twitter && (
          <div className="twitter info">
            <FontAwesomeIcon icon={faTwitterSquare} size="lg" color="#58585B" />
            <p>
              <button
                className="button-link"
                onClick={(): void => {
                  newWindow(`${companyInfo.company?.twitter}`, '')
                }}
                onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void => {
                  if (e.keyCode === 13) {
                    newWindow(`${companyInfo.company?.twitter}`, '')
                  }
                }}
                type="button"
              >
                View Twitter Profile
              </button>
            </p>
          </div>
        )}
        {companyInfo.company.facebook && (
          <div className="facebook info">
            <FontAwesomeIcon icon={faFacebookSquare} size="lg" color="#58585B" />
            <p>
              <button
                className="button-link"
                onClick={(): void => {
                  newWindow(`${companyInfo.company?.facebook}`, '')
                }}
                onKeyDown={(e: KeyboardEvent<HTMLButtonElement>): void => {
                  if (e.keyCode === 13) {
                    newWindow(`${companyInfo.company?.facebook}`, '')
                  }
                }}
                type="button"
              >
                View Facebook Profile
              </button>
            </p>
          </div>
        )}
        {companyInfo.company.other && (
          <div className="other info">
            <FontAwesomeIcon icon={faDesktop} size="lg" color="#58585B" />
            <p>{companyInfo.company.other}</p>
          </div>
        )}
        <hr className="divider" />
        {companyInfo.company.details && (
          <div className="details">
            <h4>Description:</h4>
            <p>{companyInfo.company.details}</p>
          </div>
        )}
        {companyInfo.company.details && <hr className="divider" />}
        <CircleCheckbox
          name={companyInfo.dncChecked ? 'Do Not Engage' : 'Do Not Engage Company'}
          state={companyInfo.dncChecked}
          onChangeState={(): void => {
            companyInfo.onCompanyDNCChange(!companyInfo.dncChecked)
          }}
        />
      </div>
    )
  }

  return content
}

export default inject('prospects', 'companyInfo')(withRouter(observer(AdminCompanyInfo)))
